import {Component} from '@angular/core';

@Component({
  selector: 'app-send-keys-popup',
  templateUrl: './send-key-modal.component.html'
})
export class SendKeyModalComponent{
  public keys: String;
}
